const menuPage = {
  'menuPage-title': 'Nuestro menú'
};

export default menuPage;
